export const PlayerRegistrationApiEndpoints = {
  FETCH_REGISTRATION_LINK: "/link/registration-setting",
  FETCH_PLAYER_REGISTRATION_DETAILS:
    "/registration/first-step/registration-setting",
  FETCH_PLAYERS_TO_REGISTRATION: "/registration/first-step/my-players",
  SAVE_PLAYER_REGISTRATION_DETAILS:
    "/registration/first-step/registration-setting",
  SAVE_NEW_PLAYER_REGISTRATION_DETAILS:
    "/registration/first-step/registration-setting",
  FETCH_PLAYER_REGISTRATION_SUMMARY: "/registration/second-step",
  SAVE_PLAYER_REGISTRATION_PROMO_CODE_AND_PAYMENT_PLAN:
    "/registration/second-step",
  CREATE_STRIPE_PAYMENT_INTENT:
    "/registration-setting-payment-installment/stripe-payment",
  AUTHORIZE_PAYPAL_PAYMENT:
    "/registration-setting-payment-installment/paypal-payment",
  FINALIZE_PLAYER_REGISTRATION: "/registration/second-step",
  FETCH_PLAYER_REGISTRATION_INFO:
    "/registration/first-step/registration-setting",
  UPLOAD_PLAYER_AVATAR: "/registration/first-step/avatar",
  UPLOAD_NEW_PLAYER_AVATAR: "/registration/first-step/new-player/avatar",
  UPDATE_PAYPAL_CHECKOUT_PAYMENT_STATUS:
    "/registration-setting-payment-installment/paypal-payment"
};
